"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethereumjs_util_1 = require("ethereumjs-util");
const ethers_1 = require("ethers");
const sort_deep_object_arrays_1 = __importDefault(require("sort-deep-object-arrays"));
const eth_sig_util_1 = require("@metamask/eth-sig-util");
const lodash_1 = __importDefault(require("lodash"));
;
;
const PriceData = [
    { name: "symbols", type: "bytes32[]" },
    { name: "values", type: "uint256[]" },
    { name: "timestamp", type: "uint256" },
];
const EIP712Domain = [
    { name: "name", type: "string" },
    { name: "version", type: "string" },
    { name: "chainId", type: "uint256" }
];
const serializePriceValue = (value) => Math.round(value * (Math.pow(10, 8)));
class EvmPriceSigner {
    constructor(version = "0.4", chainId = 1) {
        this._domainData = {
            name: "Redstone",
            version: version,
            chainId: chainId,
        };
    }
    getDataToSign(priceData) {
        return {
            types: {
                EIP712Domain,
                PriceData,
            },
            domain: this._domainData,
            primaryType: "PriceData",
            message: priceData,
        };
    }
    getLiteDataBytesString(priceData) {
        // Calculating lite price data bytes array
        let data = "";
        for (let i = 0; i < priceData.symbols.length; i++) {
            const symbol = priceData.symbols[i];
            const value = priceData.values[i];
            data += symbol.substr(2) + value.toString(16).padStart(64, "0");
        }
        data += Math.ceil(priceData.timestamp / 1000)
            .toString(16)
            .padStart(64, "0");
        return data;
    }
    getLiteDataToSign(priceData) {
        const data = this.getLiteDataBytesString(priceData);
        const hash = (0, ethereumjs_util_1.bufferToHex)((0, ethereumjs_util_1.keccak256)((0, ethereumjs_util_1.toBuffer)("0x" + data)));
        return hash;
    }
    calculateLiteEvmSignature(priceData, privateKey) {
        const data = this.getLiteDataToSign(priceData);
        return (0, eth_sig_util_1.personalSign)({ privateKey: (0, ethereumjs_util_1.toBuffer)(privateKey), data });
    }
    static convertStringToBytes32String(str) {
        if (str.length > 31) {
            // TODO: improve checking if str is a valid bytes32 string later
            const bytes32StringLength = 32 * 2 + 2; // 32 bytes (each byte uses 2 symbols) + 0x
            if (str.length === bytes32StringLength && str.startsWith("0x")) {
                return str;
            }
            else {
                // Calculate keccak hash if string is bigger than 32 bytes
                return ethers_1.ethers.utils.id(str);
            }
        }
        else {
            return ethers_1.ethers.utils.formatBytes32String(str);
        }
    }
    serializeToMessage(pricePackage) {
        // We clean and sort prices to be sure that prices
        // always have the same format
        const cleanPricesData = pricePackage.prices.map((p) => lodash_1.default.pick(p, ["symbol", "value"]));
        const sortedPrices = (0, sort_deep_object_arrays_1.default)(cleanPricesData);
        return {
            symbols: sortedPrices.map((p) => EvmPriceSigner.convertStringToBytes32String(p.symbol)),
            values: sortedPrices.map((p) => serializePriceValue(p.value)),
            timestamp: pricePackage.timestamp,
        };
    }
    signPricePackage(pricePackage, privateKey) {
        const serializedPriceData = this.serializeToMessage(pricePackage);
        return {
            pricePackage,
            signerAddress: (new ethers_1.ethers.Wallet(privateKey)).address,
            liteSignature: this.calculateLiteEvmSignature(serializedPriceData, privateKey),
        };
    }
    verifyLiteSignature(signedPricePackage) {
        const serializedPriceData = this.serializeToMessage(signedPricePackage.pricePackage);
        const data = this.getLiteDataToSign(serializedPriceData);
        const signer = (0, eth_sig_util_1.recoverPersonalSignature)({
            data,
            signature: signedPricePackage.liteSignature,
        });
        const signerAddressUC = signer.toUpperCase();
        const expectedSignerAddress = signedPricePackage.signerAddress;
        const expectedSignerAddressUC = expectedSignerAddress.toUpperCase();
        return signerAddressUC === expectedSignerAddressUC;
    }
}
exports.default = EvmPriceSigner;
